<template>
  <div style="width: 98%; margin: 0 auto">
    <el-form :inline="true" :model="meetingForm" class="demo-form-inline">
      <el-form-item>
        <el-select
          v-model="meetingForm.own_meeting"
          clearable
          size="small"
          style="width: 200px"
          placeholder="与我相关or所有"
        >
          <el-option label="所有会议" value="" />
          <el-option label="与我相关的会议" value="1" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="meetingForm.datatame"
          size="small"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="meetingForm.type_id"
          size="small"
          style="width: 200px"
          placeholder="会议类型"
          clearable
        >
          <el-option
            v-for="item in meetingoptions"
            :key="item.id"
            :label="item.type_name"
            :value="item.id"
            :disabled="item.id == 7"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="meetingForm.secrecy_type"
          clearable
          size="small"
          style="width: 180px"
          placeholder="会议保密类型"
        >
          <el-option label="普通会议（非保密）" value="0"
            >普通会议（非保密）</el-option
          >
          <el-option label="一级会议（保密）" value="1"
            >一级会议（保密）</el-option
          >
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input
          v-model="meetingForm.subject"
          size="small"
          placeholder="会议主题"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="meetingForm.meeting_no"
          size="small"
          placeholder="会议编号"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="meetingForm.room_id"
          size="small"
          style="width: 200px"
          placeholder="请选择会议室"
          clearable
        >
          <el-option v-for="item in roomList" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="isManager == true && meetingForm.own_meeting == ''">
        <!-- <el-input size="small" v-model="meetingForm.attendee" placeholder="参会者工号" clearable></el-input> -->
        <el-select
          v-model="meetingForm.attendee"
          :remote-method="filterUser"
          clearable
          remote
          filterable
          size="small"
          placeholder="参会人"
        >
          <el-option
            v-for="(item, index) in userList"
            :key="index"
            :value="item.workcode"
            :label="item.name + '(' + item.workcode + ')'"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="mini"
          icon="el-icon-search"
          type="primary"
          @click="onSubmit"
          >查询</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          size="mini"
          icon="el-icon-download"
          type="success"
          @click="exportAll(true)"
          >全部导出</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          size="mini"
          icon="el-icon-download"
          type="warning"
          @click="exportAll(false)"
          >批量导出</el-button
        >
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName" class="tabsBox" @tab-click="handleClick">
      <el-tab-pane
        v-for="item in statusList"
        :key="item.value"
        :label="`${item.statusName}(${status_total[item.statusType]})`"
        :name="item.value"
      />
    </el-tabs>
    <div v-if="meetings.length > 0">
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <el-card
        v-for="(item, index) in meetings"
        :key="index"
        class="box-card"
        style="margin-top: 10px"
        @dblclick.native="checkInfo(item)"
      >
        <div slot="header" class="clearfix">
          <el-checkbox style="margin-right: 10px" v-model="item.isChecked" @change="value => handleCheckedChange(value, item.id)"></el-checkbox>
          <span class="them">( 编号：{{ item.id }} )</span>
          <span class="them" @click="checkInfo(item)">{{
            item.meeting_subject
          }}</span
          >&nbsp;&nbsp;&nbsp;
          <span
            >会议时间：{{ item.estimate_start_time }} ~
            {{ item.estimate_end_time }}</span
          >&nbsp;&nbsp; <span>最后更新：{{ item.update_time }}</span
          >&nbsp;&nbsp;
        </div>
        <el-row>
          <el-col :span="2" style="min-width: 120px">
            <el-image
              :src="item.room.pictures[0]"
              :preview-src-list="item.room.pictures"
              style="width: 100px; height: 100px"
            />
            <!-- / <img :src="item.room_avatar" style="width: 100px;height:100px;" alt /> -->
          </el-col>
          <el-col :span="8">
            <div>
              <span>会议室：{{ item.room_name }}</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >会议地点：{{ item.room_address.city
                }}{{ item.room_address.address }} - {{ item.area }}</span
              >
            </div>
            <p>
              预计参会人数：{{ item.number }}人&nbsp;&nbsp;&nbsp;&nbsp;
              <span>会议类型：{{ item.meeting_type }}</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <span
                >保密类型：{{
                  item.secrecy_type === 1
                    ? "一级会议（保密）"
                    : "普通会议（非保密）"
                }}</span
              >
            </p>
            <p>所属部门：{{ item.secretary_department_name }}</p>
            <p>
              <span>召集人：{{ item.convenor.name }}</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <!-- <span>申请人: {{ item.applicant.name }}</span>&nbsp;&nbsp; -->

              <span>会议秘书：{{ item.secretary.name }}</span
              >&nbsp;&nbsp;&nbsp;&nbsp;
              <!-- <span>联系人: {{ item.contact.name }}</span>&nbsp;&nbsp; -->
              <span>主持人：{{ item.host.name }}</span>
            </p>
            <span>
              参会者：
              <span v-for="(item5, index5) in item.attendees" :key="index5"
                >{{ item5.name }} ,</span
              >
            </span>

            <!-- <p>备注：{{ item.describe }}</p> -->
            <p>
              <el-tag
                v-for="(item9, index9) in item.equipments"
                :key="index9"
                type="info"
                size="small"
                effect="plain"
                style="margin-left: 5px"
                >{{ item9.equipment_name }}</el-tag
              >
            </p>
          </el-col>
          <el-col v-if="item.isAttendees == true" :span="10">
            <!-- <div v-for="(items5, index5) in item.attendees" :key="index5">

          </div> -->
            <div
              v-if="item.meeting_status != 4 && item.meeting_status != 3"
              class="toolBox"
            >
              <!-- <h2 v-if="item.attendees_status == 1">参加</h2>
              <h2 v-if="item.attendees_status == 2">请假</h2>
              <h2 v-if="item.attendees_status == 4">拒绝</h2>
              <h2 v-if="item.attendees_status == 3">早退</h2> -->
              <h2 v-for="(item8,index8) in h2List" v-show="item.attendees_status == index8+1" :key="index8">{{item8}}</h2>

              <el-button
                v-if="
                  item.meeting_status == 0 &&
                  item.attendees_status != 2 &&
                  item.attendees_status != 4 &&
                  item.secretary.workcode != $store.getters.username &&
                  item.host.workcode != $store.getters.username &&
                  item.convenor.workcode != $store.getters.username
                "
                type="text"
                size="medium"
                @click="leave(item)"
                >请假</el-button
              >
              <el-button
                v-if="
                  item.meeting_status == 0 &&
                  item.attendees_status != 4 &&
                  item.attendees_status != 2 &&
                  item.secretary.workcode != $store.getters.username &&
                  item.host.workcode != $store.getters.username &&
                  item.convenor.workcode != $store.getters.username
                "
                type="text"
                size="medium"
                @click="attendees(item)"
                >拒绝</el-button
              >
              <!-- 会议状态 （0已预约 1进行中 2已结束 3未进行 4已取消 5决议处理中 6会议待评分 7 已完成）user_is_score 未评分 参加状态 选填 -->
              <!-- 已结束   决议处理中  未评分 参加 -->
              <!-- 结束之后，参会人填写会议任务  到 决议处理中 -->
              <span>是否需要评分：{{item.is_need_score === 1 ? '是':'否'}}</span><br>

              <el-button
                v-if="[2,3,5,6,7].includes(item.meeting_status) &&
                  !item.user_is_score &&
                  item.attendees_status === 1 &&
                  item.is_need_score === 1
                "
                type="text"
                size="medium"
                @click="submitScore(item)"
                >评分</el-button
              >
              <h3 v-if="item.user_is_score === 1">已评分</h3>
            </div>
          </el-col>
        </el-row>
        <div class="footer">
          <tags :meeting_status="item.meeting_status"></tags>
          <div style="float: right">
            <el-button
              v-if="
                item.meeting_status == 0 &&
                (item.secretary.workcode == $store.getters.username ||
                  item.host.workcode == $store.getters.username ||
                  item.convenor.workcode == $store.getters.username)
              "
              type="text"
              size="medium"
              @click="meetingstarts(item)"
              >开始会议</el-button
            >
            <el-button
              v-if="
                [0,1,2,5].includes(item.meeting_status) &&
                (item.secretary.workcode == $store.getters.username ||
                  item.host.workcode == $store.getters.username ||
                  item.convenor.workcode == $store.getters.username)
              "
              type="text"
              size="medium"
              @click="endmet(item)"
              >编辑会议</el-button
            >

            <el-button
              v-if="
                item.meeting_status == 0 &&
                (item.secretary.workcode == $store.getters.username ||
                  item.host.workcode == $store.getters.username ||
                  item.convenor.workcode == $store.getters.username)
              "
              type="text"
              size="medium"
              @click="canceltast(item)"
              >取消会议</el-button
            >
            <!-- 1进行中 -->
            <el-button
              v-if="
                item.meeting_status == 1 &&
                (item.secretary.workcode == $store.getters.username ||
                  item.host.workcode == $store.getters.username ||
                  item.convenor.workcode == $store.getters.username)
              "
              type="text"
              size="medium"
              @click="meetingends(item)"
              >结束会议</el-button
            >

            <el-button type="text" size="medium" @click="checkInfo(item)"
              >查看详情</el-button
            >
            <!-- 会议召集人和会议秘书默认显示此按钮，点击按钮可重新给未评分的参会人员推送评分 决议处理和已结束tab-->
            <el-button
              v-if="
                ['2','5'].includes(activeName) && item.is_need_score === 1 &&
                [item.convenor.workcode,item.secretary.workcode].includes($store.getters.username)
              "
              type="text"
              size="medium"
              @click="pushScore(item)"
              >推送评分</el-button
            >
          </div>
        </div>
      </el-card>
    </div>
    <el-card
      v-if="meetings.length == 0"
      class="box-card"
      style="margin-top: 10px"
    >
      <div>无数据</div>
    </el-card>
    <div style="margin-top: 10px; text-align: center">
      <el-pagination
        :page-sizes="[2, 5, 10, 30]"
        :total="total"
        :current-page="page"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 选择取消原因 -->
    <el-dialog
      :visible.sync="cancelReasonVisible"
      :before-close="closePop"
      title="请选择取消原因"
      width="800px"
    >
      <el-form
        ref="cancelForm"
        :model="cancelForm"
        :rules="rule"
        :inline="false"
      >
        <el-form-item
          label="取消原因"
          label-width="120px"
          prop="cancel_reason_id"
        >
          <el-select
            v-model="cancelForm.cancel_reason_id"
            clearable
            style="width: 98%"
          >
            <el-option
              v-for="(item, index) in reasonList"
              :key="index"
              :value="item.id"
              :label="item.name"
              :disabled="item.disabled"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" type="info" @click="closePop">取消</el-button>
        <el-button size="small" type="primary" @click="cancelSub"
          >确定</el-button
        >
      </div>
    </el-dialog>
      <endMettingDialog :propData="propData"  @close="closeDialog" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  meetingsearch,
  meetingcancel,
  meetingstart,
  sendDingScore,
  meetingStatusCount
} from '@/api/seedetails'
import {
  meetingtype,
  attendees,
  attendeesleave,
  roomData,
  downloadData
} from '@/api/conferencebooking'
import { getList } from '@/api/cancelReason'
import { searchDepartment } from '@/api/department'
import { gitusers } from '@/api/user'
import tags from '@/components/tags'

import endMettingDialog from './component/endMettingDialog'

export default {
  components: {
    tags,
    endMettingDialog
  },
  data() {
    return {
      checkAll: false,
      isIndeterminate: true,
      checkedArr: [],
      checkedArrPage: [],
      cancelReasonVisible: false,
      cancelForm: {
        reason: '',
        cancel_reason_id: ''
      },
      h2List: ['参加', '请假', '早退', '拒绝'],
      statusList: [
        {
          statusName: '已预约',
          statusType: 'booking',
          value: '0'
        },
        {
          statusName: '进行中',
          statusType: 'progress',
          value: '1'
        },
        {
          statusName: '已结束',
          statusType: 'end_num',
          value: '2'
        },
        {
          statusName: '未进行',
          statusType: 'noprogress',
          value: '3'
        },
        {
          statusName: '已取消',
          statusType: 'cancel',
          value: '4'
        },
        {
          statusName: '决议处理中',
          statusType: 'resolution',
          value: '5'
        },
        {
          statusName: '待评分',
          statusType: 'score',
          value: '6'
        },
        {
          statusName: '已完成',
          statusType: 'complete',
          value: '7'
        },
        {
          statusName: '全部',
          statusType: 'all_num',
          value: '8'
        }
      ],
      rule: {
        cancel_reason_id: [
          { required: true, message: '请选择取消会议原因', trigger: 'change' }
        ]
      },
      reasonList: [],
      cancelMeetId: null,
      value1: '',
      total: 0,
      page: 1,
      pageSize: 2,
      meetingoptions: [],
      meeting_status: [0],
      meetings: [],
      activeName: '0',
      meetingForm: {
        datatame: [],
        subject: '',
        secrecy_type: null,
        own_meeting: '1',
        meeting_no: '',
        attendee: '',
        room_id: ''
      },
      roomList: [],
      starttime: '',
      status_total: {
        booking: 0,
        progress: 0,
        end_num: 0,
        noprogress: 0,
        cancel: 0,
        complete: 0,
        resolution: 0,
        score: 0,
        all_num: 0
      },
      isManager: false,
      mangerList: [],
      allUsers: [],
      userList: [],
      propData: { visible: false, form: {}}
    }
  },
  computed: {
    ...mapGetters(['roles'])
  },
  watch: {
    'meetingForm.own_meeting': function(val) {
      if (val === '') {
        this.mangerList.forEach((item) => {
          if (item.workcode === this.$store.getters.username) {
            this.isManager = true
          }
        })
      }
    }
  },
  created() {
    // this.getList()
  },
  mounted() {
    this.getmeetingsearch()
    this.getCount()
    this.getRoomList()
    meetingtype()
      .then((response) => {
        console.log(response)
        this.meetingoptions = response.data.types
      })
      .catch((err) => {
        console.log(err)
      })
    this.getReasonList()
    this.getManagerList()
    this.getUser()
  },
  methods: {
    // 选择框点击
    handleCheckedChange(isChecked, id) {
      if (isChecked) {
        this.checkedArr.push(id)
        this.checkedArrPage.push(id)
      } else {
        this.checkedArr.splice(this.checkedArr.indexOf(id))
        this.checkedArrPage.splice(this.checkedArrPage.indexOf(id))
      }
      const checkedCount = this.checkedArrPage.length
      this.checkAll = checkedCount === this.meetings.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.meetings.length
    },
    handleCheckAllChange(val) {
      this.meetings.forEach(item => {
        item.isChecked = val
        if (val) {
          if (this.checkedArr.indexOf(item.id) === -1) {
            this.checkedArr.push(item.id)
            this.checkedArrPage.push(item.id)
          }
        } else {
          this.checkedArr.splice(this.checkedArr.indexOf(item.id))
          this.checkedArrPage.splice(this.checkedArrPage.indexOf(item.id))
        }
      })
      this.isIndeterminate = false
    },
    exportAll(isAll) {
      const params = {
        type_id: this.meetingForm.type_id,
        subject: this.meetingForm.subject,
        estimate_start_time:
          this.meetingForm.datatame == null ? '' : this.meetingForm.datatame[0],
        estimate_end_time:
          this.meetingForm.datatame == null ? '' : this.meetingForm.datatame[1],
        // meeting_no: this.meetingForm.meeting_no,
        meeting_status: this.meeting_status,
        own_meeting: this.meetingForm.own_meeting,
        room_id: this.meetingForm.room_id,
        secrecy_type: this.meetingForm.secrecy_type,
        workcode: this.$store.getters.username,
        meeting_no: isAll ? '' : this.checkedArr.join(',')
      }
      if (this.isManager === true && this.meetingForm.own_meeting === '') {
        params.attendee = this.meetingForm.attendee
      }
      downloadData(params).then(res => {
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(res)
          elink.download = '大杂会表格数据.xls'
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(res, '大杂会表格数据.xls')
        }
      }).catch(err => console.log(err))
    },
    // 获取会议室列表数据
    getRoomList() {
      roomData().then(res => {
        if (res.code === 'success' && res.data) {
          this.roomList = res.data
        }
      }).catch(err => console.log(err))
    },
    // 查询有配置部门权限的所有用户列表(管理员，显示工号查询)
    getManagerList() {
      this.isManager = false
      this.mangerList = []
      searchDepartment().then((res) => {
        if (res.code === 'success' && res.data.role) {
          if (res.data.role.length) {
            this.mangerList = res.data.role
            console.log(this.mangerList)
          }
        }
      })
    },
    // 取消会议原因
    getReasonList() {
      const params = {
        page: 1,
        page_size: 1000
      }
      getList(params)
        .then((response) => {
          if (response.code === 'success' && response.data.reason.length) {
            this.reasonList = response.data.reason
            this.reasonList.forEach((item) => {
              item.disabled = false
            })
          } else {
            const json = {
              name: '尚未配置取消会议原因，请联系秘书处理！',
              disabled: true
            }
            this.reasonList = [json]
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getUser() {
      gitusers({ departmentId: 0 })
        .then((res) => {
          if (res.code === '000000' && res.data) {
            this.allUsers = res.data
          } else {
            this.allUsers = []
          }
        })
        .catch(() => {
          this.allUsers = []
        })
    },
    filterUser(val) {
      if (val) {
        setTimeout(() => {
          this.userList = this.allUsers.filter((item) => {
            return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.userList = []
      }
    },
    onSubmit() {
      this.page = 1
      this.getmeetingsearch()
      this.getCount()
    },
    // 日期转时间戳
    transdate(endTime) {
      var date = new Date()
      date.setFullYear(endTime.substring(0, 4))
      date.setMonth(endTime.substring(5, 7) - 1)
      date.setDate(endTime.substring(8, 10))
      date.setHours(endTime.substring(11, 13))
      date.setMinutes(endTime.substring(14, 16))
      date.setSeconds(endTime.substring(17, 19))
      return Date.parse(date) / 1000
    },

    meetingstarts(item) {
      this.$confirm('确认开始会议, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          meetingstart({
            meeting_id: item.id,
            is_night: 0
          })
            .then((response) => {
              if (response.code === 'success') {
                this.$message({
                  type: 'success',
                  message: '成功!'
                })
                this.$store.dispatch('getMeetingRun')
                this.getmeetingsearch()
                this.getCount()
              }
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch(() => {})
    },

    meetingends(item) {
      this.propData = {
        form: { ...item, is_held: 1 },
        visible: true
      }
      // this.$confirm('确认结束会议111, 是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      //   .then(() => {
      //     meetingend({
      //       meeting_id: item.id,
      //       is_night: 0
      //     })
      //       .then((response) => {
      //         this.$message({
      //           type: 'success',
      //           message: '成功!'
      //         })
      //         this.$store.dispatch('getMeetingRun')
      //         this.getmeetingsearch()
      //         this.getCount()
      //       })
      //       .catch((err) => {
      //         console.log(err)
      //       })
      //   })
      //   .catch(() => {})
    },
    handleClick(tab, event) {
      this.checkedArr = []
      if (tab.index === '8') {
        this.meeting_status = []
      } else {
        this.meeting_status = [tab.index]
      }
      this.page = 1
      this.getmeetingsearch()
      this.getCount()
    },

    leave(id) {
      this.$confirm(
        '请先联系此会议的召集人:' + id.convenor.name + '，确认后再请假！',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$prompt('请输入请假内容', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /\S/,
            inputErrorMessage: '请输入请假原因'
          })
            .then(({ value }) => {
              attendeesleave({
                meeting_id: id.id,
                reason: value,
                is_night: 0
              })
                .then((response) => {
                  this.$message({
                    message: '操作成功',
                    type: 'success'
                  })
                  this.getmeetingsearch()
                })
                .catch((err) => {
                  console.log(err)
                })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '取消输入'
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },

    attendees(id) {
      this.$confirm(
        '请先联系此会议的召集人:' + id.convenor.name + '，确认后再拒绝！',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$prompt('请输入拒绝内容', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: /\S/,
            inputErrorMessage: '请输入拒绝原因'
          })
            .then(({ value }) => {
              attendees({
                meeting_id: id.id,
                reason: value,
                is_night: 0
              })
                .then((response) => {
                  this.$message({
                    message: '操作成功',
                    type: 'success'
                  })
                  this.getmeetingsearch()
                })
                .catch((err) => {
                  console.log(err)
                })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '取消输入'
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    checkInfo(id) {
      this.$router.push({
        name: 'seeDetails',
        query: {
          id: id.id
        }
      })
    },
    submitScore(id) {
      this.$router.push({
        name: 'score',
        query: {
          id: id.id
        }
      })
    },
    canceltast(item) {
      this.cancelReasonVisible = true
      this.cancelMeetId = item.id
    },
    closePop() {
      this.$refs.cancelForm.resetFields()
      this.cancelReasonVisible = false
      this.cancelMeetId = ''
    },
    cancelSub() {
      this.$refs.cancelForm.validate((valid) => {
        if (valid) {
          let reason = ''
          this.reasonList.forEach((item) => {
            if (item.id === this.cancelForm.cancel_reason_id) {
              reason = item.name
            }
          })
          const params = {
            meeting_id: this.cancelMeetId,
            reason: reason,
            cancel_reason_id: this.cancelForm.cancel_reason_id
          }
          meetingcancel(params)
            .then((response) => {
              console.log(response)
              if (response.code === 'success') {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                })
                this.page = 1
                this.getmeetingsearch()
                this.getCount()
                this.closePop()
              } else {
                this.$message.error(response.message)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        } else {
          return false
        }
      })
    },
    endmet(id) {
      this.$router.push({
        name: 'endemett',
        query: {
          id: id.id,
          meeting_room_id: id.room.id
        }
      })
    },
    getmeetingsearch() {
      const params = {
        type_id: this.meetingForm.type_id,
        subject: this.meetingForm.subject,
        secrecy_type: this.meetingForm.secrecy_type
          ? parseInt(this.meetingForm.secrecy_type)
          : null,
        estimate_start_time:
          this.meetingForm.datatame == null ? '' : this.meetingForm.datatame[0],
        estimate_end_time:
          this.meetingForm.datatame == null ? '' : this.meetingForm.datatame[1],
        meeting_status: this.meeting_status,
        meeting_no: this.meetingForm.meeting_no,
        own_meeting: this.meetingForm.own_meeting,
        room_id: this.meetingForm.room_id,
        workcode: this.$store.getters.username,
        page: this.page,
        page_size: this.pageSize
      }
      if (this.isManager === true && this.meetingForm.own_meeting === '') {
        params.attendee = this.meetingForm.attendee
      }
      this.mettingsSearch(params)
    },
    mettingsSearch(params) {
      meetingsearch(params)
        .then((response) => {
          console.log(response)
          this.total = response.data.pagination.total
          // this.meetings = response.data.meetings;
          const list = response.data.meetings
          // 计算自己在不在参会人之间，如果不在隐藏请假等按钮
          for (const i in list) {
            for (const j in list[i].attendees) {
              if (
                list[i].attendees[j].workcode === this.$store.getters.username
              ) {
                // 在参会人中给个标识
                list[i].isAttendees = true
              }
            }
            // 处理已选中数据的回显
            if (this.checkedArr.includes(list[i].id)) {
              list[i].isChecked = true
            } else {
              list[i].isChecked = false
            }
          }
          this.meetings = list
          // this.status_total = response.data.status_total

          const checkedCount = this.checkedArrPage.length
          this.checkAll = checkedCount === this.meetings.length
          this.isIndeterminate = checkedCount > 0 && checkedCount < this.meetings.length
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 数量统计
    getCount() {
      const params = {
        type_id: this.meetingForm.type_id,
        subject: this.meetingForm.subject,
        estimate_start_time:
          this.meetingForm.datatame == null ? '' : this.meetingForm.datatame[0],
        estimate_end_time:
          this.meetingForm.datatame == null ? '' : this.meetingForm.datatame[1],
        meeting_no: this.meetingForm.meeting_no,
        meeting_status: this.meeting_status,
        own_meeting: this.meetingForm.own_meeting,
        room_id: this.meetingForm.room_id,
        secrecy_type: this.meetingForm.secrecy_type,
        workcode: this.$store.getters.username
      }
      if (this.isManager === true && this.meetingForm.own_meeting === '') {
        params.attendee = this.meetingForm.attendee
      }
      meetingStatusCount(params).then((response) => {
        console.log('统计', response)
        if (response.code === 'success') {
          this.status_total = response.data
        }
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getmeetingsearch()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getmeetingsearch()
    },
    closeDialog(type) {
      this.propData.visible = false
      if (type) { // 编辑成功调用查询
        this.onSubmit()
      }
    },
    pushScore(row) {
      this.$confirm('此操作将重新给未评分的参会人员推送评分, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sendDingScore({ meeting_id: row.id }).then(res => {
          if (res.code === 'success') {
            this.$message({
              type: 'success',
              message: '成功!'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    }
  }
}
</script>

<style style lang="scss" scoped>
.box-card {
  font-size: 14px;
  color: rgb(94, 90, 90);
  /* margin: 10px 15px; */
}

.title {
  font-size: 20px;
  color: #000;
}

.toolBox {
  text-align: end;
}

.footer {
  border-top: 1px solid #ebeef5;
}

.them {
  font-weight: 700;
  font-size: 14px;
}
</style>
